import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideAlert } from "../../slices/Alert/reducer";

const Alert = () => {
    const dispatch: any = useDispatch();
    const { isShow, type, title, content } = useSelector((state: any) => state.Alert);
    const onClose = () => {
        dispatch(hideAlert());
    };

    const renderIcon = () => {
        switch (type) {
            case "success":
                return <i className="mdi mdi-check-circle-outline text-success"></i>;
            case "danger":
                return <i className="mdi mdi-close-octagon-outline text-danger"></i>;
            case "warning":
                return <i className="mdi mdi-alert-outline text-warning"></i>;
            default:
                return <i className="mdi mdi-information-outline text-info"></i>;
        }
    }

    return (
        <div
            className={`toast pwa-install-alert shadow bg-white ${
                isShow ? "show" : "hide"
            }`}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            data-bs-delay="5000"
            data-bs-autohide="true"
        >
            <div className="toast-body">
                <div className="content d-flex align-items-center mb-2">
                    {renderIcon()}
                    <h6 className="mb-0">{title}</h6>
                    <button
                        className="btn-close ms-auto"
                        type="button"
                        data-bs-dismiss="toast"
                        aria-label="Close"
                        onClick={onClose}
                    ></button>
                </div>
                <span className="mb-0 d-block">{content}</span>
            </div>
        </div>
    );
};

export default Alert;
